<template>
  <div v-if="user" class="row">
    <div class="col-md-8">
        <user-edit-card :user="user"/>
        <user-password-card :user="user"/>
    </div>
    <div class="col-md-4">
      <user-card :user="user"/>
    </div>
  </div>
</template>

<script>
  import UserEditCard from "@/pages/User/EditProfileCard.vue";
  import UserPasswordCard from "@/pages/User/EditPasswordCard.vue";
  import UserCard from '../Profile/UserCard';

  export default {
    name: "user-profile",

    components: {
      UserPasswordCard,
      UserEditCard,
      UserCard
    },

    data: () => ({
      user: {
        name: "",
        email: "",
      },
    }),

    created() {
      this.getProfile();
    },

    methods: {
      async getProfile() {
          this.user = this.$store.state.user;
      }
    }
  }
</script>